/**
 * Badge del estado de pago de una orden (presentacional).
 *
 * Distingue visualmente "pagado/para despacho/crédito" (verde, listo para
 * entregar) de "pendiente de pago" (gris) y "abonado" (ámbar, pago parcial). Sin
 * lógica de negocio: recibe el estado de pago y pinta etiqueta/color.
 */
import { cn } from "@/components/ui";

import { PAYMENT_LABEL } from "../constants";
import type { PaymentStatus } from "../types";

const PAYMENT_CLASS: Record<PaymentStatus, string> = {
  pendiente_de_pago: "bg-slate-100 text-slate-700",
  pagada_para_despacho: "bg-green-100 text-green-800",
  abonado: "bg-amber-100 text-amber-800",
  pagado: "bg-green-100 text-green-800",
  orden_a_credito: "bg-green-100 text-green-800",
};

export function PaymentBadge({ payment }: { payment: PaymentStatus }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        PAYMENT_CLASS[payment],
      )}
    >
      {PAYMENT_LABEL[payment]}
    </span>
  );
}
